// src/components/TestimonialsSection.js

function TestimonialsSection() {
  const testimonials = [
    {
      name: "Grace Mwangi",
      comment:
        "ENW Advocates gave me the best legal support during a stressful land case. Professional and committed.",
    },
    {
      name: "David Otieno",
      comment:
        "The team was responsive, knowledgeable, and guided me through a complex employment issue with ease.",
    },
    {
      name: "Corporate Client",
      comment:
        "Their attention to detail in our company restructuring process was top-notch. Highly recommended for corporate law.",
    },
  ];

  return (
    <section className="bg-white text-deepgreen px-6 py-24">
      <div className="max-w-6xl mx-auto text-center" data-aos="fade-up">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-12">Client Testimonials</h2>
        <div className="grid gap-8 md:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gray-50 p-8 rounded-xl shadow-lg relative text-left hover:-translate-y-1 transition duration-300"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              {/* Quote Icon */}
              <div className="absolute top-4 right-6 text-6xl text-gold opacity-20 font-serif">”</div>
              
              <p className="text-gray-700 mb-6 italic relative z-10 leading-relaxed">
                "{testimonial.comment}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-1 bg-gold"></div>
                <p className="font-bold font-serif text-deepgreen">{testimonial.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;
